import React, { useRef, useState } from "react";
import "./Home.css";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import { Autoplay, Pagination, Navigation } from "swiper/modules";





const Service = () => {

  const data = [
    {
      name: "Rhinoplasty",
      description:
        "We provide comprehensive rhinoplasty services, ensuring meticulous documentation and prioritizing client satisfaction throughout the process.",
      link: "/rhinoplasty",
      img: "https://img.freepik.com/free-photo/beautiful-female-three-quarters-portrait-isolated-blue-studio-backgroud-young-emotional-lovely-woman-is-standing-human-emotions-facial-expression-concept-profile-view-trendy-colors_155003-45175.jpg?t=st=1728387511~exp=1728391111~hmac=7835ac9d045668e3b85031c5e4f100a791bc870f0ce841b499662af324aebf03&w=740",
      icon: "https://cdn-icons-png.freepik.com/512/9774/9774144.png?ga=GA1.2.12114912.1717589849",
    },
    {
      name: "Gynaecomastia",
      description:
        "We offer complete gynecomastia treatment, ensuring thorough documentation and prioritizing client satisfaction at every stage.",
      link: "/gynaecomastia",
      img: "https://img.freepik.com/free-photo/caucasian-man-blue-tones_23-2149132249.jpg?t=st=1728387425~exp=1728391025~hmac=51eb9f8f4d65cbc33cc645c5d15e38aa23dfe95fd0972954ca9f85354655e430&w=740",
      icon: "https://cdn-icons-png.freepik.com/512/16743/16743511.png?ga=GA1.2.12114912.1717589849",
    },
    {
      name: "Lipoma Removal",
      description:
        "We provide comprehensive lipoma removal services, ensuring detailed documentation and prioritizing client satisfaction throughout the process.",
      link: "/lipoma-removal",
      img: "https://img.freepik.com/free-photo/doctor-testing-patient-eyesight_23-2149230059.jpg?t=st=1733121956~exp=1733125556~hmac=22a2c6b8d1236ca49c5eb1425ad906356919d114e1372f848800f6e0a0dbd203&w=740",
      icon: "https://cdn-icons-png.freepik.com/512/9774/9774144.png?ga=GA1.2.12114912.1717589849",
    },
    {
      name: "Ophthalmology",
      description:
        "We offer comprehensive cataract removal services, ensuring detailed documentation and prioritizing patient satisfaction throughout the process.",
      link: "/ophthalmology",
      img: "https://img.freepik.com/free-photo/doctor-testing-patient-eyesight_23-2149230059.jpg?t=st=1733121956~exp=1733125556~hmac=22a2c6b8d1236ca49c5eb1425ad906356919d114e1372f848800f6e0a0dbd203&w=740",
      icon: "https://cdn-icons-png.freepik.com/512/4025/4025276.png?ga=GA1.1.12114912.1717589849",
    },
  ];


  return (
    <div>
      <section className="what-we-do-2 what-we-do-2__space theme-bg-heading-primary overflow-hidden ">
        <div className="overlay overlay-bold"></div>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="section__title-wrapper text-center mb-20">
                <span className="section__subtitle text-white text-center">
                  What We Offer
                </span>
                <h2
                  className="section__title text-white title-animation"
                  style={{ perspective: 100 }}
                >
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      translate: "none",
                      rotate: "none",
                      scale: "none",
                      transformOrigin: "35.6953px 32px",
                      transform: "translate(0px, 0px)",
                      opacity: 1,
                      visibility: "inherit",
                      fontSize: "46px",
                      fontWeight: "800",
                    }}
                  >
                    We Are Experts In
                  </div>{" "}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="what-we-do-inner-sectionss">
        <Container>
          <Row>
            <Swiper
              slidesPerView={3}
              spaceBetween={10}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              breakpoints={{
                "@0.00": {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                "@0.75": {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                "@1.00": {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
                "@1.50": {
                  slidesPerView: 4,
                  spaceBetween: 50,
                },
              }}
              modules={[Autoplay]}
              className="mySwiper"
            >
              {data &&
                data.map((item) => (
                  <SwiperSlide>
                    <div
                      className="featured-imagebox featured-imagebox-portfolio style4"
                      style={{ margin: "0px" }}
                    >
                      {/* featured-thumbnail */}
                      <div className="featured-thumbnail">
                        <Link to="#" tabIndex={0}>
                          <img
                            width={584}
                            height={760}
                            className="img-fluid"
                            src={item.img}
                            alt="image"
                            style={{ objectFit: "cover" }}
                          />
                        </Link>
                      </div>
                      {/* featured-thumbnail end*/}
                      <div className="featured-content">
                        <div className="featured-icon">
                          <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                            <img
                              src={item.icon}
                              className="flaticon flaticon-workspace"
                              style={{ width: "60px", height: "60px" }}
                            />
                          </div>
                        </div>
                        <div className="featured-title">
                          <h3>
                            <Link>{item.name}</Link>
                          </h3>
                        </div>
                        <div className="featured-desc">
                          <p style={{ fontSize: "16px" }}>{item.description}</p>
                        </div>
                        <div className="ttm-footer">
                          <Link
                            to={item.link}
                            className="ttm-btn ttm-btn-size-md ttm-btn-shape-squar ttm-btn-style-border ttm-icon-btn-right ttm-btn-color-darkgrey"
                          >
                            Read More
                          </Link>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
            </Swiper>
          </Row>

          <Row className="justify-content-center service_section_display_change">
            <div
              className="col-lg-3 col-md-3 col-sm-6 slick-slide slick-current slick-active"
              // style={{ width: 400 }}
            >
              {/* featured-imagebox-portfolio */}
              <div className="featured-imagebox featured-imagebox-portfolio style4">
                {/* featured-thumbnail */}
                <div className="featured-thumbnail">
                  <Link to="#" tabIndex={0}>
                    <img
                      width={584}
                      height={760}
                      className="img-fluid"
                      src="https://img.freepik.com/free-photo/beautiful-female-three-quarters-portrait-isolated-blue-studio-backgroud-young-emotional-lovely-woman-is-standing-human-emotions-facial-expression-concept-profile-view-trendy-colors_155003-45175.jpg?t=st=1728387511~exp=1728391111~hmac=7835ac9d045668e3b85031c5e4f100a791bc870f0ce841b499662af324aebf03&w=740"
                      alt="image"
                      style={{ objectFit: "cover" }}
                    />
                  </Link>
                </div>
                {/* featured-thumbnail end*/}
                <div className="featured-content">
                  <div className="featured-icon">
                    <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                      <img
                        src="https://cdn-icons-png.freepik.com/512/9774/9774144.png?ga=GA1.2.12114912.1717589849"
                        className="flaticon flaticon-workspace"
                        style={{ width: "60px", height: "60px" }}
                      />
                    </div>
                  </div>
                  <div className="featured-title">
                    <h3>
                      <Link>Rhinoplasty</Link>
                    </h3>
                  </div>
                  <div className="featured-desc">
                    <p>
                      We provide comprehensive rhinoplasty services, ensuring
                      meticulous documentation and prioritizing client
                      satisfaction throughout the process.
                    </p>
                  </div>
                  <div className="ttm-footer">
                    <Link
                      to="/rhinoplasty"
                      className="ttm-btn ttm-btn-size-md ttm-btn-shape-squar ttm-btn-style-border ttm-icon-btn-right ttm-btn-color-darkgrey"
                    >
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
              {/* featured-imagebox-portfolio end*/}
            </div>

            <div
              className="col-lg-3 col-md-3 col-sm-6 slick-slide slick-active"
              // style={{ width: 400 }}
            >
              {/* featured-imagebox-portfolio */}
              <div className="featured-imagebox featured-imagebox-portfolio style4 active">
                {/* featured-thumbnail */}
                <div className="featured-thumbnail">
                  <Link to="#" tabIndex={0}>
                    <img
                      width={584}
                      height={760}
                      className="img-fluid"
                      src="https://img.freepik.com/free-photo/caucasian-man-blue-tones_23-2149132249.jpg?t=st=1728387425~exp=1728391025~hmac=51eb9f8f4d65cbc33cc645c5d15e38aa23dfe95fd0972954ca9f85354655e430&w=740"
                      alt="image"
                    />
                  </Link>
                </div>
                {/* featured-thumbnail end*/}
                <div className="featured-content">
                  <div className="featured-icon">
                    <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                      <img
                        src="https://cdn-icons-png.freepik.com/512/16743/16743511.png?ga=GA1.2.12114912.1717589849"
                        className="flaticon flaticon-apartment"
                      />
                    </div>
                  </div>
                  <div className="featured-title">
                    <h3>
                      <Link>Gynaecomastia</Link>
                    </h3>
                  </div>
                  <div className="featured-desc">
                    <p>
                      We offer complete gynecomastia treatment, ensuring
                      thorough documentation and prioritizing client
                      satisfaction at every stage.
                    </p>
                  </div>
                  <div className="ttm-footer">
                    <Link
                      to="/gynaecomastia"
                      className="ttm-btn ttm-btn-size-md ttm-btn-shape-squar ttm-btn-style-border ttm-icon-btn-right ttm-btn-color-white"
                      style={{ color: "#fff", border: "1px solid #fff" }}
                    >
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
              {/* featured-imagebox-portfolio end*/}
            </div>
            <div
              className="col-lg-3 col-md-3 col-sm-6 slick-slide slick-current slick-active"
              // style={{ width: 400 }}
            >
              {/* featured-imagebox-portfolio */}
              <div className="featured-imagebox featured-imagebox-portfolio style4">
                {/* featured-thumbnail */}
                <div className="featured-thumbnail">
                  <Link to="#" tabIndex={0}>
                    <img
                      width={584}
                      height={760}
                      className="img-fluid"
                      src="/Images/Lipoma.jpg"
                      // src="https://img.freepik.com/premium-photo/close-up-boho-styled-woman-hands-with-silver-jewelry_152904-34417.jpg?w=900"
                      alt="image"
                    />
                  </Link>
                </div>
                {/* featured-thumbnail end*/}
                <div className="featured-content">
                  <div className="featured-icon">
                    <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                      <img
                        src="/Images/lipo.png"
                        style={{ height: "60px", width: "60px" }}
                        className="flaticon flaticon-workspace"
                      />
                    </div>
                  </div>
                  <div className="featured-title">
                    <h3>
                      <Link tabIndex={0}>lipoma removal</Link>
                    </h3>
                  </div>
                  <div className="featured-desc">
                    <p>
                      We provide comprehensive lipoma removal services, ensuring
                      detailed documentation and prioritizing client
                      satisfaction throughout the process.
                    </p>
                  </div>
                  <div className="ttm-footer">
                    <Link
                      to="/lipoma-removal"
                      className="ttm-btn ttm-btn-size-md ttm-btn-shape-squar ttm-btn-style-border ttm-icon-btn-right ttm-btn-color-darkgrey"
                    >
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
              {/* featured-imagebox-portfolio end*/}
            </div>
            <div
              className="col-lg-3 col-md-3 col-sm-6 slick-slide slick-current slick-active"
              // style={{ width: 400 }}
            >
              {/* featured-imagebox-portfolio */}
              <div className="featured-imagebox featured-imagebox-portfolio style4">
                {/* featured-thumbnail */}
                <div className="featured-thumbnail">
                  <Link to="#" tabIndex={0}>
                    <img
                      width={584}
                      height={760}
                      className="img-fluid"
                      src="https://img.freepik.com/free-photo/doctor-testing-patient-eyesight_23-2149230059.jpg?t=st=1733121956~exp=1733125556~hmac=22a2c6b8d1236ca49c5eb1425ad906356919d114e1372f848800f6e0a0dbd203&w=740"
                      // src="https://img.freepik.com/premium-photo/close-up-boho-styled-woman-hands-with-silver-jewelry_152904-34417.jpg?w=900"
                      alt="image"
                    />
                  </Link>
                </div>
                {/* featured-thumbnail end*/}
                <div className="featured-content">
                  <div className="featured-icon">
                    <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                      <img
                        src="https://cdn-icons-png.freepik.com/512/4025/4025276.png?ga=GA1.1.12114912.1717589849"
                        style={{ height: "60px", width: "60px" }}
                        className="flaticon flaticon-workspace"
                      />
                    </div>
                  </div>
                  <div className="featured-title">
                    <h3>
                      <Link tabIndex={0}>Ophthalmology</Link>
                    </h3>
                  </div>
                  <div className="featured-desc">
                    <p>
                      We offer comprehensive cataract removal services, ensuring
                      detailed documentation and prioritizing patient
                      satisfaction throughout the process.{" "}
                    </p>
                  </div>
                  <div className="ttm-footer">
                    <Link
                      to="/ophthalmology "
                      className="ttm-btn ttm-btn-size-md ttm-btn-shape-squar ttm-btn-style-border ttm-icon-btn-right ttm-btn-color-darkgrey"
                    >
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
              {/* featured-imagebox-portfolio end*/}
            </div>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Service;
